import type { ResolvedNavSection } from '@sazeo/sdk';
import { createContext, useContext } from 'react';

export const NavContext = createContext<ResolvedNavSection[]>([]);

export function useNav(): ResolvedNavSection[] {
  return useContext(NavContext);
}
